// Each brand's downloadable logos on the CDN (lifestyle/logos/<brand>/), as in its logo zip.
// File names are as uploaded (including ik's "blacik").
export const BRAND_LOGOS = {
  windalert: {
    zip: 'wa-logos-2026-10-07.zip',
    files: [
      'wa-logo-2-color-transparent-large.png',
      'wa-logo-black-transparent-large.png',
      'wa-logo-gray-transparent-large.png',
      'wa-logo-white-transparent-large.png',
      'wa-logo-slogan-2-color-transparent-large.png',
      'wa-logo-slogan-black-transparent-large.png',
      'wa-logo-slogan-gray-transparent-large.png',
      'wa-logo-slogan-white-transparent-large.png'
    ]
  },
  ikitesurf: {
    zip: 'ik-logos-2026-10-07.zip',
    files: [
      'ik-logo-2-color-transparent-large.png',
      'ik-logo-2-color-transparent-small.png',
      'ik-logo-black-transparent-large.png',
      'ik-logo-gray-transparent-large.png',
      'ik-logo-white-transparent-large.png',
      'ik-logo-white-transparent-small.png',
      'ik-logo-slogan-2-color-transparent-large.png',
      'ik-logo-slogan-2-color-transparent-small.png',
      'ik-logo-slogan-blacik-transparent-large.png',
      'ik-logo-slogan-gray-transparent-large.png',
      'ik-logo-slogan-white-transparent-large.png',
      'ik-logo-circle-small.png'
    ]
  },
  iwindsurf: {
    zip: 'iw-logos-2026-10-07.zip',
    files: [
      'iw-logo-2-color-transparent-large.png',
      'iw-logo-black-transparent-large.png',
      'iw-logo-gray-transparent-large.png',
      'iw-logo-white-transparent-large.png',
      'iw-logo-slogan-2-color-transparent-large.png',
      'iw-logo-slogan-2-color-transparent-small.png',
      'iw-logo-slogan-black-transparent-large.png',
      'iw-logo-slogan-gray-transparent-large.png',
      'iw-logo-slogan-white-transparent-large.png'
    ]
  },
  fishweather: {
    zip: 'fw-logos-2026-10-07.zip',
    files: [
      'fw-logo-color-transparent-large.png',
      'fw-logo-slogan-color-transparent-large.png',
      'fw-logo-slogan-color-transparent-small.png',
      'fw-logo-slogan-black-transparent-large.png',
      'fw-logo-slogan-gray-transparent-large.png',
      'fw-logo-slogan-white-transparent-large.png'
    ]
  },
  sailflow: {
    zip: 'sf-logos-2026-10-07.zip',
    files: [
      'sf-logo-2-color-transparent-large.png',
      'sf-logo-black-transparent-large.png',
      'sf-logo-gray-transparent-large.png',
      'sf-logo-white-transparent-large.png',
      'sf-logo-slogan-2-color-transparent-large.png',
      'sf-logo-slogan-2-color-transparent-small.png',
      'sf-logo-slogan-black-transparent-large.png',
      'sf-logo-slogan-gray-transparent-large.png'
    ]
  }
}
